import { ApolloError } from '@apollo/client';
import { isNil } from 'ramda';

import { getLocalizedErrorMessage } from '../../errors';
import { getServerErrorCode } from '../../errors/utils';
import locales from './locales';

const getErrorCodeMessageIfPossible = (error: ApolloError) => {
  const possibleCode = getServerErrorCode(error);

  if (possibleCode === undefined) {
    return null;
  }

  return getLocalizedErrorMessage(possibleCode);
};

interface GetErrorMessageArgs {
  error: unknown;
  handleUnrecognizedErrors?: boolean;
  unrecognizedErrorMessage?: string;
}

const getErrorMessageIfPossible = ({
  error,
  handleUnrecognizedErrors,
  unrecognizedErrorMessage,
}: GetErrorMessageArgs): string | null => {
  if (error instanceof ApolloError && !isNil(error.networkError)) {
    return locales.connectionErrorMessage;
  }

  if (error instanceof ApolloError && !isNil(error.graphQLErrors)) {
    const apolloErrorMessage = getErrorCodeMessageIfPossible(error);

    if (apolloErrorMessage !== null) {
      return apolloErrorMessage;
    }
  }

  if (handleUnrecognizedErrors && unrecognizedErrorMessage) {
    return unrecognizedErrorMessage;
  }

  return null;
};

export default getErrorMessageIfPossible;
